import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import InputText from "../InputText/InputText";
import withSizes from "react-sizes";
import Loader from "../Loader/Loader";

const WithValidation = styled.div`
  max-width: 700px;
  height: ${props => (props.url && !props.noEmbed ? "500px" : "50px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export default withSizes(({ width }) => {
  const componentWidth = width >= 950 ? 900 : width - 80;
  return {
    width: componentWidth,
    height: Math.floor((componentWidth * 9) / 16)
  };
})(({ url, onChange, readonly, noEmbed }) => {
  const [link, setLink] = useState(url || "");
  const ref = useRef();
  return (
    <WithValidation url={url} noEmbed={noEmbed}>
      {!readonly && (
        <InputText
          ref={ref}
          placeholder="e.g. https://coolactivity/12"
          value={link}
          onChange={e => {
            setLink(e.target.value);
          }}
          onBlur={() => {
            if (onChange) {
              onChange(link);
            }
          }}
          onEnter={() => {
            if (onChange) {
              onChange(link);
            }
          }}
        ></InputText>
      )}
      {!noEmbed && (
        <a href={url} className={url ? "embedly-card" : ""}>
          {url && <Loader />}
        </a>
      )}
    </WithValidation>
  );
});
